import React, { useCallback, useState } from 'react';
import moment from 'moment';
import Modal, { ModalBody, ModalFooter, ModalHeader, ModalTitle } from '@atlaskit/modal-dialog';
import Button from '@atlaskit/button/standard-button';
import Calendar from '@atlaskit/calendar';
import { getFormattedDateString } from '@css-xp/base';

type CalendarProps = React.ComponentProps<typeof Calendar>;

type CalendarDialogProps = {
  closeModal: () => void;
  onSelect: (selectedTimestamp: string) => void;
  selectedTimestamp?: string;
  validNextBillDateRange: { start: CalendarProps['minDate']; end: CalendarProps['maxDate'] };
  disabledDateFilter?: CalendarProps['disabledDateFilter'];
};

const calendarDateFormat = 'YYYY-MM-DD';

// TODO: Make it generic if we need to keep this calendar / datepicker UI. For now it is a stopgap for rollout.
export const CalendarDialog = (props: CalendarDialogProps) => {
  const { closeModal, onSelect, selectedTimestamp } = props;

  const formattedSelectedDate = getFormattedDateString({ date: selectedTimestamp, format: calendarDateFormat });

  const [selectedDate, setSelectedDateTimestamp] = useState(formattedSelectedDate);

  const handleOkBtn = useCallback(() => {
    if (!selectedDate) return;

    const updatedTimestamp = `${moment.utc(selectedDate).valueOf()}`;
    onSelect(updatedTimestamp);
    closeModal();
  }, [closeModal, onSelect, selectedDate]);

  return (
    <Modal onClose={closeModal} width="small" testId="uof.modal.set-next-bill-date-calendar-dialog">
      <ModalHeader>
        <ModalTitle>Please choose a bill date</ModalTitle>
      </ModalHeader>
      <ModalBody>
        <Calendar
          defaultSelected={selectedDate ? [selectedDate] : undefined}
          defaultPreviouslySelected={formattedSelectedDate ? [formattedSelectedDate] : undefined}
          onSelect={(selectedDate) => {
            setSelectedDateTimestamp(selectedDate.iso);
          }}
          minDate={props.validNextBillDateRange.start}
          maxDate={props.validNextBillDateRange.end}
          disabledDateFilter={props.disabledDateFilter}
        />
      </ModalBody>
      <ModalFooter>
        <Button appearance="primary" onClick={handleOkBtn} isDisabled={!selectedDate} autoFocus>
          Ok
        </Button>
      </ModalFooter>
    </Modal>
  );
};
